module.exports = __webpack_public_path__ + "img/setTop.38d4d025.svg";